<template>
  <div>
    <el-tabs v-model="obj.category" @tab-click="handleTabClick">
      <el-tab-pane label="自选" name="favorites"></el-tab-pane>
      <el-tab-pane label="全部A股" name="all"></el-tab-pane>
      <el-tab-pane label="上证A股" name="shse"></el-tab-pane>
      <el-tab-pane label="深证A股" name="szse"></el-tab-pane>
      <el-tab-pane label="北证A股" name="bse"></el-tab-pane>
      <el-tab-pane label="上证主板" name="shse_zb"></el-tab-pane>
      <el-tab-pane label="深证主板" name="szse_zb"></el-tab-pane>
      <el-tab-pane label="科创版" name="shse_kcb"></el-tab-pane>
      <el-tab-pane label="创业版" name="szse_cyb"></el-tab-pane>
      <el-tab-pane label="沪深300" name="hs300"></el-tab-pane>
      <el-tab-pane label="上证50" name="sz50"></el-tab-pane>
      <el-tab-pane label="中证500" name="zz500"></el-tab-pane>
      <el-tab-pane label="中证1000" name="zz1000"></el-tab-pane>
      <el-tab-pane label="创业300" name="cy300"></el-tab-pane>
      <el-tab-pane label="科创50" name="kc50"></el-tab-pane>
      <el-tab-pane label="北证50" name="bz50"></el-tab-pane>
      <!-- <el-tab-pane label="行业板块" name="industry"></el-tab-pane> -->
    </el-tabs>
    <el-tabs v-model="obj.category" @tab-click="handleTabClick" v-if="obj.showIndustry == true">
      <el-tab-pane v-for="data in obj.selectIndustryList" :key="data" :label="data.label"
        :name="data.value"></el-tab-pane>
    </el-tabs>
    <div v-if="obj.category === 'favorites'">
      <el-button type="primary" @click="handleFavorites">
        <el-icon class="el-input__icon">
          <star />
        </el-icon>编辑自选
      </el-button>
    </div>
    <el-table :data="obj.dataList" style="width: 100%" height="100%" empty-text=""
      :style="'height:' + (store.state.windowHeight - 255) + 'px'" :cell-style="cellStyle" @row-click="handleRowClick">
      <el-table-column fixed label="序号" prop="no" width="60px" align="right" />
      <el-table-column fixed label="名称" prop="name" width="100px" align="right" sortable />
      <el-table-column label="代码" prop="symbol" width="100px" align="right" sortable />
      <el-table-column label="最新" prop="close" width="80px" align="right" />
      <el-table-column label="涨跌" prop="chg" width="80px" align="right" :sort-method="customStrSort" sortable />
      <el-table-column label="涨跌幅" prop="chgPct" width="90px" align="right" :sort-method="customPctSort" sortable />
      <el-table-column label="开盘" prop="open" width="80px" align="right" />
      <el-table-column label="最低" prop="low" width="80px" align="right" />
      <el-table-column label="最高" prop="high" width="80px" align="right" />
      <el-table-column label="成交量" prop="vol" width="90px" align="right" :sort-method="customVolSort" sortable />
      <el-table-column label="成交额" prop="turnover" width="100px" align="right" :sort-method="customTurnoverSort" sortable />
      <el-table-column label="前收" prop="preClose" width="80px" align="right" />
      <el-table-column label="趋势度" prop="trend_ma1" width="100px" align="right" sortable/>
      <el-table-column label="换手率" prop="turnoverRate_ma1" width="100px" align="right" :sort-method="customTurnoverRateSort" sortable/>
      <el-table-column label="振幅" prop="amplitude" width="100px" align="right" :sort-method="customAmplitudeSort" sortable/>
      <el-table-column prop="industry" label="行业" width="120px" align="right" />
      <el-table-column prop="index" label="指数" width="180px" align="right" />
      <el-table-column prop="district" label="地区" width="80px" align="right" />
    </el-table>
    <el-pagination background layout="prev, pager, next" :page-size="obj.limit" :total="obj.total"
      :current-page="obj.page" class="mt-16 mb-16" @current-change="handlePageChange"></el-pagination>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { http, httpNoLoading } from '../util/http'
import { bigNumberTransform, formatDecimalPoint, isMarketTime } from '../util/base'
export default {
  setup() {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const router = useRouter()
    const store = useStore()
    const obj = reactive({
      category: 'favorites',
      dataList: [],
      total: 0,
      page: 1,
      limit: 100,
      // timer: null

      selectIndustryList: [
        { 'value': '煤炭开采', 'label': '1002 煤炭开采' },
        { 'value': '焦炭加工', 'label': '1005 焦炭加工' },
        { 'value': '油气开采', 'label': '1007 油气开采' },
        { 'value': '石油化工', 'label': '1011 石油化工' },
        { 'value': '油服工程', 'label': '1008 油服工程' },
        { 'value': '日用化工', 'label': '1016 日用化工' },
        { 'value': '化纤', 'label': '1019 化纤' },
        { 'value': '化学原料', 'label': '1026 化学原料' },
        { 'value': '化学制品', 'label': '1034 化学制品' },
        { 'value': '塑料', 'label': '1044 塑料' },
        { 'value': '橡胶', 'label': '1051 橡胶' },
        { 'value': '农用化工', 'label': '1055 农用化工' },
        { 'value': '非金属材料', 'label': '1104 非金属材料' },
        { 'value': '冶钢原料', 'label': '1062 冶钢原料' },
        { 'value': '普钢', 'label': '1065 普钢' },
        { 'value': '特钢', 'label': '1069 特钢' },
        { 'value': '工业金属', 'label': '1071 工业金属' },
        { 'value': '贵金属', 'label': '1075 贵金属' },
        { 'value': '能源金属', 'label': '1078 能源金属' },
        { 'value': '稀有金属', 'label': '1082 稀有金属' },
        { 'value': '金属新材料', 'label': '1087 金属新材料' },
        { 'value': '水泥', 'label': '1091 水泥' },
        { 'value': '玻璃玻纤', 'label': '1094 玻璃玻纤' },
        { 'value': '装饰建材', 'label': '1097 装饰建材' },
        { 'value': '种植业', 'label': '1106 种植业' },
        { 'value': '养殖业', 'label': '1111 养殖业' },
        { 'value': '林业', 'label': '1115 林业' },
        { 'value': '渔业', 'label': '1116 渔业' },
        { 'value': '饲料', 'label': '1119 饲料' },
        { 'value': '农产品加工', 'label': '1123 农产品加工' },
        { 'value': '动物保健', 'label': '1127 动物保健' },
        { 'value': '酿酒', 'label': '1130 酿酒' },
        { 'value': '饮料乳品', 'label': '1136 饮料乳品' },
        { 'value': '调味品', 'label': '1139 调味品' },
        { 'value': '休闲食品', 'label': '1140 休闲食品' },
        { 'value': '食品加工', 'label': '1144 食品加工' },
        { 'value': '纺织制造', 'label': '1151 纺织制造' },
        { 'value': '服装家纺', 'label': '1157 服装家纺' },
        { 'value': '饰品', 'label': '1162 饰品' },
        { 'value': '造纸', 'label': '1167 造纸' },
        { 'value': '包装印刷', 'label': '1171 包装印刷' },
        { 'value': '家居用品', 'label': '1177 家居用品' },
        { 'value': '文娱用品', 'label': '1180 文娱用品' },
        { 'value': '白色家电', 'label': '1184 白色家电' },
        { 'value': '黑色家电', 'label': '1187 黑色家电' },
        { 'value': '小家电', 'label': '1190 小家电' },
        { 'value': '厨卫电器', 'label': '1194 厨卫电器' },
        { 'value': '家电零部件', 'label': '1198 家电零部件' },
        { 'value': '一般零售', 'label': '1200 一般零售' },
        { 'value': '商业物业经营', 'label': '1204 商业物业经营' },
        { 'value': '专业连锁', 'label': '1205 专业连锁' },
        { 'value': '贸易', 'label': '1206 贸易' },
        { 'value': '电子商务', 'label': '1207 电子商务' },
        { 'value': '乘用车', 'label': '1212 乘用车' },
        { 'value': '商用车', 'label': '1215 商用车' },
        { 'value': '汽车零部件', 'label': '1218 汽车零部件' },
        { 'value': '汽车服务', 'label': '1224 汽车服务' },
        { 'value': '摩托车及其他', 'label': '1227 摩托车及其他' },
        { 'value': '化学制药', 'label': '1231 化学制药' },
        { 'value': '生物制品', 'label': '1234 生物制品' },
        { 'value': '中药', 'label': '1256 中药' },
        { 'value': '医药商业', 'label': '1252 医药商业' },
        { 'value': '医疗器械', 'label': '1241 医疗器械' },
        { 'value': '医疗服务', 'label': '1247 医疗服务' },
        { 'value': '医疗美容', 'label': '1257 医疗美容' },
        { 'value': '电机制造', 'label': '1261 电机制造' },
        { 'value': '电池', 'label': '1262 电池' },
        { 'value': '电网设备', 'label': '1268 电网设备' },
        { 'value': '光伏设备', 'label': '1275 光伏设备' },
        { 'value': '风电设备', 'label': '1282 风电设备' },
        { 'value': '其他发电设备', 'label': '1285 其他发电设备' },
        { 'value': '地面兵装', 'label': '1287 地面兵装' },
        { 'value': '航空装备', 'label': '1288 航空装备' },
        { 'value': '航天装备', 'label': '1289 航天装备' },
        { 'value': '航海装备', 'label': '1290 航海装备' },
        { 'value': '军工电子', 'label': '1291 军工电子' },
        { 'value': '轨交设备', 'label': '1293 轨交设备' },
        { 'value': '通用设备', 'label': '1294 通用设备' },
        { 'value': '专用设备', 'label': '1303 专用设备' },
        { 'value': '工程机械', 'label': '1310 工程机械' },
        { 'value': '自动化设备', 'label': '1313 自动化设备' },
        { 'value': '半导体', 'label': '1319 半导体' },
        { 'value': '消费电子', 'label': '1326 消费电子' },
        { 'value': '光学光电', 'label': '1329 光学光电' },
        { 'value': '元器件', 'label': '1333 元器件' },
        { 'value': '其他电子', 'label': '1336 其他电子' },
        { 'value': '通信设备', 'label': '1338 通信设备' },
        { 'value': '通信工程', 'label': '1347 通信工程' },
        { 'value': '电信服务', 'label': '1344 电信服务' },
        { 'value': 'IT设备', 'label': '1352 IT设备' },
        { 'value': '软件服务', 'label': '1355 软件服务' },
        { 'value': '云服务', 'label': '1359 云服务' },
        { 'value': '产业互联网', 'label': '1364 产业互联网' },
        { 'value': '游戏', 'label': '1369 游戏' },
        { 'value': '广告营销', 'label': '1370 广告营销' },
        { 'value': '影视院线', 'label': '1373 影视院线' },
        { 'value': '数字媒体', 'label': '1376 数字媒体' },
        { 'value': '出版业', 'label': '1380 出版业' },
        { 'value': '广播电视', 'label': '1384 广播电视' },
        { 'value': '全国性银行', 'label': '1386 全国性银行' },
        { 'value': '地方性银行', 'label': '1389 地方性银行' },
        { 'value': '证券', 'label': '1394 证券' },
        { 'value': '保险', 'label': '1395 保险' },
        { 'value': '多元金融', 'label': '1396 多元金融' },
        { 'value': '房屋建设', 'label': '1406 房屋建设' },
        { 'value': '基础建设', 'label': '1407 基础建设' },
        { 'value': '专业工程', 'label': '1410 专业工程' },
        { 'value': '工程咨询服务', 'label': '1415 工程咨询服务' },
        { 'value': '装修装饰', 'label': '1416 装修装饰' },
        { 'value': '房地产开发', 'label': '1418 房地产开发' },
        { 'value': '房产服务', 'label': '1422 房产服务' },
        { 'value': '体育', 'label': '1427 体育' },
        { 'value': '教育培训', 'label': '1428 教育培训' },
        { 'value': '酒店餐饮', 'label': '1429 酒店餐饮' },
        { 'value': '旅游', 'label': '1432 旅游' },
        { 'value': '专业服务', 'label': '1436 专业服务' },
        { 'value': '公路铁路', 'label': '1442 公路铁路' },
        { 'value': '航空机场', 'label': '1446 航空机场' },
        { 'value': '航运港口', 'label': '1449 航运港口' },
        { 'value': '物流', 'label': '1452 物流' },
        { 'value': '电力', 'label': '1459 电力' },
        { 'value': '燃气', 'label': '1467 燃气' },
        { 'value': '水务', 'label': '1468 水务' },
        { 'value': '环保设备', 'label': '1470 环保设备' },
        { 'value': '环境治理', 'label': '1471 环境治理' },
        { 'value': '环境监测', 'label': '1476 环境监测' },
        { 'value': '综合类', 'label': '1478 综合类' }
      ],
      selectedIndustryValue: '',
      showIndustry: true
    })

    // 自选对话框关闭后传来的事件处理
    vueEvent.on('favoritesDialogClose', (flag) => {
      // 自动跳转到自选页面
      obj.category = 'favorites'
      handleFavoritesDialogClose()
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      vueEvent.emit('navbarMenuIdxEvent', '1')
      vueEvent.emit('sidebarMenuIdxEvent', '')
      renderView()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      // clearInterval(obj.timer)
      vueEvent.off('favoritesDialogClose', () => { })
    })

    // 渲染画面
    const renderView = () => {
      // 是否存在缓存
      if (store.state.marketData === '') {
        // 无缓存，从后台请求数据
        requestData()
      } else {
        // 有缓存，设定页面状态
        getStore()
      }
    }

    // 获取合约列表
    const requestData = (isLoading = true) => {
      let formData = new FormData()
      formData.append("category", obj.category)
      formData.append("page", obj.page)
      formData.append("limit", obj.limit)
      if (isLoading) {
        http({
          url: `/market`,
          method: 'post',
          data: formData
        }).then((res) => {
          // console.log(res.data.data)
          processData(res.data.data)
          setStore()
        }).catch((err) => {
          // clearInterval(obj.timer)
        })
      } else {
        httpNoLoading({
          url: `/market`,
          method: 'post',
          data: formData
        }).then((res) => {
          processData(res.data.data)
          setStore()
        }).catch((err) => {
          // clearInterval(obj.timer)
        })
      }
    }

    // 加工处理数据
    const processData = (data) => {
      let no = 1
      data.data.forEach((item) => {
        if (item.chgPct !== "-") {
          item.chgPct = (item.chgPct * 100).toFixed(2) + '%'
          item.chg = item.chg.toFixed(2)
          item.volForSort = parseFloat(item.vol)
          item.vol = bigNumberTransform(parseFloat(item.vol / 100)) // 总量计算方式：vol除以100，把股转为手
          item.turnoverForSort = parseFloat(item.turnover)
          item.turnover = bigNumberTransform(parseFloat(item.turnover))
          item.turnoverRate_ma1 = (item.turnoverRate_ma1 * 100).toFixed(2) + '%'
          item.amplitude = (item.amplitude * 100).toFixed(2) + '%'
        }
        item.no = no
        no++

        if (item.index == "") {
          item.index = "-"
        }
        if (item.industry == "") {
          item.industry = "-"
        }
        if (item.district == "") {
          item.district = "-"
        }
      })
      obj.total = data.total
      obj.dataList = data.data
    }

    // 保存Store
    const setStore = () => {
      var storeObj = {
        'category': obj.category,
        'dataList': obj.dataList,
        'date': obj.date,
        'total': obj.total,
        'page': obj.page,
        'showIndustry': obj.showIndustry,
      }
      store.commit('setMarketData', storeObj)
    }

    // 获取Store
    const getStore = () => {
      obj.category = store.state.marketData.category
      obj.dataList = store.state.marketData.dataList
      obj.date = store.state.marketData.date
      obj.total = store.state.marketData.total
      obj.page = store.state.marketData.page
      obj.showIndustry = store.state.marketData.showIndustry
    }


    // tab点击事件
    const handleTabClick = (tab) => {
      // console.log(tab.props.name)
      // if (tab.props.name == "industry") {
      //   obj.showIndustry = true
      //   console.log(obj.showIndustry)
      // } else {
      //   obj.showIndustry = false
      //   obj.category = tab.props.name
      //   obj.page = 1
      //   requestData()
      // }
      obj.category = tab.props.name
      obj.page = 1
      requestData()
    }

    // tab2点击事件
    const handleTabClick2 = (tab) => {
      obj.category = tab.props.name
      obj.page = 1
      requestData()
    }

    // 按钮打开自选
    const handleFavorites = (e) => {
      vueEvent.emit('favoritesDialogVisible', true)
    }

    // 自选对话框关闭后的回调方法
    const handleFavoritesDialogClose = (e) => {
      requestData()
    }

    // 表格行点击事件
    const handleRowClick = (row) => {
      // console.log(row.name)
      const name = row.name
      store.commit('setCurrentContract', row.name)
      router.push(`/candlestick?name=${name}`)
    }

    // 表格排序(文字型的数字列)
    const customStrSort = (a, b) => {
      return parseFloat(a.chg) - parseFloat(b.chg)
    }

    // 表格排序(带百分号的数字列)
    const customPctSort = (a, b) => {
      return parseFloat(a.chgPct.replace('%', '')) - parseFloat(b.chgPct.replace('%', ''))
    }

    // 表格排序(带金额单位的数字列)
    const customVolSort = (a, b) => {
      return a.volForSort - b.volForSort
    }

    // 表格排序(带金额单位的数字列)
    const customTurnoverSort = (a, b) => {
      return a.turnoverForSort - b.turnoverForSort
    }

    // 表格排序(带百分号的数字列)
    const customTurnoverRateSort = (a, b) => {
      return parseFloat(a.turnoverRate_ma1.replace('%', '')) - parseFloat(b.turnoverRate_ma1.replace('%', ''))
    }

    // 表格排序(带百分号的数字列)
    const customAmplitudeSort = (a, b) => {
      return parseFloat(a.amplitude.replace('%', '')) - parseFloat(b.amplitude.replace('%', ''))
    }

    // 分页变化事件
    const handlePageChange = (value) => {
      obj.page = value
      requestData()
    }

    // 表格单元格样式
    const cellStyle = (row, column, rowIndex, columnIndex) => {
      if (row.row.chg > 0 && row.columnIndex === 4) {
        return { color: 'red' }
      } else if (row.row.chg < 0 && row.columnIndex === 4) {
        return { color: 'green' }
      }
      if (row.row.chgPct.toString().replace('%', '') > 0 && row.columnIndex === 5) {
        return { color: 'red' }
      } else if (row.row.chgPct.toString().replace('%', '') < 0 && row.columnIndex === 5) {
        return { color: 'green' }
      }
      if (row.row.open > row.row.preClose && row.columnIndex === 6) {
        return { color: 'red' }
      } else if (row.row.open < row.row.preClose && row.columnIndex === 6) {
        return { color: 'green' }
      }
      if (row.row.low > row.row.preClose && row.columnIndex === 7) {
        return { color: 'red' }
      } else if (row.row.low < row.row.preClose && row.columnIndex === 7) {
        return { color: 'green' }
      }
      if (row.row.high > row.row.preClose && row.columnIndex === 8) {
        return { color: 'red' }
      } else if (row.row.high < row.row.preClose && row.columnIndex === 8) {
        return { color: 'green' }
      }
      if (row.row.close > row.row.preClose && row.columnIndex === 3) {
        return { color: 'red' }
      } else if (row.row.close < row.row.preClose && row.columnIndex === 3) {
        return { color: 'green' }
      }
      if (row.row.trend_ma1 > 0 && row.columnIndex === 12) {
        return { color: 'red' }
      } else if (row.row.trend_ma1 < 0 && row.columnIndex === 12) {
        return { color: 'green' }
      }
    }

    return {
      obj,
      store,
      handleTabClick,
      handleTabClick2,
      handleFavorites,
      handleRowClick,
      customStrSort,
      customPctSort,
      customVolSort,
      customTurnoverSort,
      customTurnoverRateSort,
      customAmplitudeSort,
      handlePageChange,
      cellStyle
    }
  }

}
</script>
<style lang="scss"></style>
